/// <reference path="../../app.definition.ts" />

import { Serializable } from "./Serializable";

export class SearchResult implements Serializable<SearchResult> {

    documentId: number;
    type: string;
    keyword: string;
    title: string;
    filename: string;
    careRecipientFirstName: string;
    careRecipientLastName: string;
    postedByFirstName: string;
    postedByLastName: string;
    subjectId: number;
    isDocument: boolean;
    isDiscussion: boolean;
    date: Date;
    endDate: Date;

    crFullName: string;
    authorFullName: string;

    deserialize(input) {
        !!input.documentId && (this.documentId = input.documentId);
        !!input.type && (this.type = input.type);
        !!input.keyword && (this.keyword = input.keyword);
        !!input.title && (this.title = input.title);
        !!input.filename && (this.filename = input.filename);
        !!input.careRecipientFirstName && (this.careRecipientFirstName = input.careRecipientFirstName);
        !!input.careRecipientLastName && (this.careRecipientLastName = input.careRecipientLastName);
        !!input.careRecipientFirstName && input.careRecipientLastName && (this.crFullName = input.careRecipientFirstName + ' ' + input.careRecipientLastName);
        !!input.postedByFirstName && (this.postedByFirstName = input.postedByFirstName);
        !!input.postedByLastName && (this.postedByLastName = input.postedByLastName);
        !!input.postedByFirstName && input.postedByLastName && (this.authorFullName = input.postedByFirstName + ' ' + input.postedByLastName);
        !!input.authorFullName && (this.authorFullName = input.authorFullName);
        !!input.subjectId && (this.subjectId = input.subjectId);
        !!input.isDocument && (this.isDocument = input.isDocument);
        !!input.isDiscussion && (this.isDiscussion = input.isDiscussion);
        !!input.date && (this.date = input.date);
        !!input.endDate && (this.endDate = input.endDate);
        return this;
    }

    constructor(input?) {
        !!input && this.deserialize(input);
    }

}
